import AddToCart from "./AddToCart";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React from "react";
import FakeStoreApi from "./FakeStoreApi";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<FakeStoreApi />} />
        <Route path="/cart" element={<AddToCart />} />
      </Routes>
    </Router>
  );
}

export default App;
